import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import { useJsonLd, usePageMeta } from "@/hooks/usePageMeta";
import HeroSection from "./components/HeroSection";
import Ticker from "./components/Ticker";
import FeaturedSection from "./components/FeaturedSection";
import TopicsSection from "./components/TopicsSection";
import HotSection from "./components/HotSection";
import MethodSection from "./components/MethodSection";
import FaqPreviewSection from "./components/FaqPreviewSection";
import ContactCta from "./components/ContactCta";

export default function Home() {
  usePageMeta({
    title: "吃瓜深扒社 - 选美吃瓜内定黑幕与评委评分猫腻解析",
    description:
      "选美比赛结果有内幕？吃瓜深扒社聚焦选美吃瓜内定与黑幕，整理评委评分猫腻、幕后交易线索与爆冷瞬间，用可核查的线索帮你理清赛果背后的门道。",
    keywords: "选美吃瓜,选美吃瓜内定,选美吃瓜黑幕,选美吃瓜评委,选美吃瓜幕后交易",
    path: "/",
  });

  useJsonLd("home", {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": "https://dstcm.cn/#website",
        name: "吃瓜深扒社",
        url: "https://dstcm.cn/",
        inLanguage: "zh-CN",
        description:
          "聚焦选美吃瓜内定与黑幕，整理评委评分猫腻、幕后交易线索与爆冷瞬间的中文内容站。",
        potentialAction: {
          "@type": "SearchAction",
          target:
            "https://dstcm.cn/topics?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@type": "Organization",
        "@id": "https://dstcm.cn/#organization",
        name: "吃瓜深扒社",
        url: "https://dstcm.cn/",
        email: "contact@chiguashenba.com",
        description:
          "专注选美赛事深度解析，把评分口径、评委构成、计分流程与合约条款摆上台面，让内定与黑幕的说法可以被核对。",
      },
      {
        "@type": "WebPage",
        "@id": "https://dstcm.cn/#webpage",
        url: "https://dstcm.cn/",
        name: "选美吃瓜内定黑幕与评委评分猫腻解析",
        isPartOf: { "@id": "https://dstcm.cn/#website" },
        about: { "@id": "https://dstcm.cn/#organization" },
        inLanguage: "zh-CN",
      },
    ],
  });

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroSection />
        <Ticker />
        <FeaturedSection />
        <TopicsSection />
        <HotSection />
        <MethodSection />
        <FaqPreviewSection />
        <ContactCta />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}